export const postLesson = {
  // 評価選択肢
  rating5: '最高だった！',
  rating4: 'よかった',
  rating3: 'まあまあ',
  rating2: 'イマイチ',
  rating1: 'よくなかった',

  // バリデーション
  validationRating: 'レッスン評価を選択してください',
  validationNextDate: '次回希望日時を入力してください',
  loginRequired: 'ログインが必要です',

  // 送信完了
  doneTitle: '送信完了！',
  doneBody: 'フォームの送信ありがとうございます。<br />次回のレッスン日程が決まったら、またメールでご連絡します！',
  toMyPage: 'マイページへ',

  // ヘッダー
  heading: 'レッスン後フォーム',
  subtitle: 'お疲れ様でした！学んだことと次回の希望を送ってください ✨',

  // セクション
  ratingTitle: 'レッスン評価',
  nextScheduleTitle: '次回希望日時',
  timezoneLabel: 'タイムゾーン：',
  dateLabel: '日付',
  timeLabel: '時間',
  timePlaceholder: '選択',
  wordPoolTitle: 'Word Pool 投稿フレーズ',
  wordPoolHelper: '今日のレッスンで学んだフレーズを1行ずつ入力してください（任意）。後でAdmin審査を経て公開されます。',
  phrasesPlaceholder: '例：\nおつかれさま\nなるほど\nよろしくお願いします',
  notesTitle: '備考・感想',
  notesPlaceholder: '気になったこと・運営へのメッセージなど（任意）',

  // 送信
  submitting: '送信中...',
  submit: 'フォームを送信する',
};
